export enum VideoPolicyRules {

    GOOGLE_UPDATED_VIDEO_POLICY = "google_uvp",
    STANDARD = "standard"
}